<template>
  <div>
    <UiSingleSelect
      v-model="currentSection"
      :title="pluralToSingular(sectionName)"
      label="title"
      :select-object-without-reduce-key="true"
      :search-through-api="true"
      :options="usersSectionList"
      class="flex-1"
      :disabled="!currentClassScope"
      :is-position-top="isPositionTop"
      drop-down-container="w-full text-xxs sm:text-xs md:text-xs lg:text-sm"
      :select-box-classes="`h-9 md:h-10 ${
        isBlinking && 'shadow-purple-100 border-primary-purple-300'
      }`"
      container-classes="min-w-[108px]"
      title-classes="pl-3 sm:pl-0 lg:text-sm sm:text-xxs text-[9px]"
      input-value-classes="text-xxs sm:text-xs md:text-xs lg:text-sm"
      :no-error="true"
      :hide-title="isTabView"
      @search="filterSections"
      @deSelect="switchSection(currentSection)"
      @change="switchSection(currentSection)"
      @notifyToSelectInput="notifySelectClassFirst"
    />
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import FILTER_KEYS from '@src/constants/filter-constants.js'
import { buildWhereQuery } from '@utils/filters/index'
import UiSingleSelect from '@components/UiElements/UiSingleSelect.vue'
import { pluralToSingular } from '@/src/utils/generalUtil'
import { useBlinkField, BLINK_KEYS } from '@src/utils/layoutUtils.js'

export default {
  components: {
    UiSingleSelect,
  },
  props: {
    hideTitle: {
      type: Boolean,
      default: false,
    },
    isPositionTop: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      currentSection: '',
      sectionBlinkField: false,
    }
  },
  computed: {
    ...mapState({
      currentCampusScope: (state) => state.layout.currentCampusScope,
      currentClassScope: (state) => state.layout.currentClassScope,
      currentSectionScope: (state) => state.layout.currentSectionScope,
      isTabView: (state) => state.layout.isTabView,
      usersSectionList: (state) => state.section.usersSectionList,
      ...mapGetters('featureNaming', ['sectionName']),
    }),
    isBlinking() {
      return this.getBlinkField ? this.getBlinkField() : false
    },
  },
  watch: {
    currentCampusScope: {
      handler() {
        this.filterUsersSectionsList()
        this.setcurrentSelectedSection('')
        this.currentSection = ''
      },
    },
    currentClassScope: {
      handler() {
        this.setcurrentSelectedSection('')
        this.filterUsersSectionsList()
        this.currentSection = ''
      },
    },
    currentSectionScope: {
      handler() {
        if (this.currentSectionScope?.id && this.stopBlinking) {
          this.stopBlinking()
        }
      },
    },
    blinkClassTrigger() {
      if (this.getBlinkField && !this.getBlinkField()) {
        this.blinkSectionField()
      }
    },
    getBlinkField: {
      handler(newVal) {
        if (typeof newVal === 'function') {
          this.sectionBlinkField = newVal()
        }
      },
      immediate: true,
    },
  },
  created() {
    const api = useBlinkField && useBlinkField(BLINK_KEYS.SECTION)
    if (api) {
      this.blinkSectionField = api.startBlink
      this.stopBlinking = api.stopBlink
      this.getBlinkField = api.getBlink
    }
    if (this.currentCampusScope && this.currentClassScope) {
      this.filterUsersSectionsList()
      this.currentSection = this.currentSectionScope
    }
  },
  methods: {
    pluralToSingular,
    switchSection(section) {
      if (this.stopBlinking) {
        this.stopBlinking()
      }
      this.setcurrentSelectedSection(section)
      this.getClassSections()
    },
    notifySelectClassFirst() {
      if (!this.currentClassScope) {
        if (!this.currentCampusScope) {
          this.$store.commit(
            'toast/NEW',
            { type: 'error', message: this.$t('toast.SELECT_CAMPUS_FIRST') },
            { root: true },
          )
          if (this.$parent.blinkCampusField) {
            this.$parent.blinkCampusField()
          }
          this.$store.commit('layout/TRIGGER_BLINK_CAMPUS', 0, { root: true })
        } else {
          this.$store.commit(
            'toast/NEW',
            { type: 'error', message: this.$t('toast.SELECT_CLASS_FIRST') },
            { root: true },
          )
          if (this.$parent.blinkClassField) {
            this.$parent.blinkClassField()
          }
          this.$store.commit('layout/TRIGGER_BLINK_CLASS', 0, { root: true })
        }
      }
    },

    /**
     * Search Class
     * @description Searches class on the basis of the query provided with debounce
     */
    filterSections(query = '') {
      const payload = {
        $where: { ...buildWhereQuery(FILTER_KEYS.ILIKE, 'title', query) },
      }
      this.filterUsersSectionsList(payload)
    },
    ...mapActions('section', ['getClassSections', 'filterUsersSectionsList']),
    ...mapActions('layout', ['setcurrentSelectedSection']),
  },
}
</script>

<style lang="scss" module>
.dropDownPosition {
  top: 47px;
  width: 248px;
  border-radius: 9px;
  box-shadow: 1px 1px 15px #0003;
  @media only screen and (max-width: 1440px) {
    width: 199px;
  }
  @media only screen and (max-width: 1024px) {
    width: 271px;
  }
  @media only screen and (max-width: 600px) {
    width: 208px;
  }
}

body[dir='ltr'] {
  .dropDownPosition {
    right: -32px;
    left: -9px;
  }
}

body[dir='rtl'] {
  .dropDownPosition {
    right: -9px;
    left: -32px;
  }
}
</style>

<style lang="scss" scoped>
.borderBottom {
  border-bottom: 0.5px solid rgb(219, 216, 216);
}
.borderBottom:last-child {
  border-bottom: none;
}
.section-dropdown {
  width: 112px;
  @media only screen and (max-width: 1024px) {
    width: 63px;
  }
  @media only screen and (max-width: 1023px) {
    width: 112px;
  }
  @media only screen and (max-width: 475px) {
    width: 63px;
  }
}
</style>
